// @ts-nocheck

export const localeCodes =  [
  "en",
  "ar"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_6fbdd192",
      load: () => import("#nuxt-i18n/6fbdd192" /* webpackChunkName: "locale_en_46js_6fbdd192" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46js_919b3334",
      load: () => import("#nuxt-i18n/919b3334" /* webpackChunkName: "locale_ar_46js_919b3334" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    iso: "en-US",
    dir: "ltr",
    language: undefined
  },
  {
    code: "ar",
    name: "العربية",
    iso: "ar-EG",
    dir: "rtl",
    language: undefined
  }
]

